import { Box, Group, Stack, Text } from "@mantine/core";
import { distanceFromMe } from "helpers/location";
import { getDataSourcePillText } from "helpers/practitioner";
import { FC, useEffect, useState } from "react";

interface Props {
  practitioner: any;
  index: number;
  onClick: () => void;
};

const ListItem: FC<Props> = ({ index, practitioner, onClick }) => {
  const [distance, setDistance] = useState<number | null>(null);
  // distinguishes "still waiting on the (single, shared) location request" from
  // "the request settled and we have no distance to show"
  const [isDistanceResolved, setIsDistanceResolved] = useState(false);
  const dataSourcePillText = getDataSourcePillText(practitioner);

  // Use default address (same as baseball card) instead of first address
  const defaultAddress = practitioner?.addresses?.find(
    (a: any) => a.id === practitioner?.default_address
  ) || practitioner?.addresses?.[0];
  const address = defaultAddress;

  useEffect(() => {
    let cancelled = false;

    if (!defaultAddress?.latitude || !defaultAddress?.longitude) {
      setIsDistanceResolved(true);
      return;
    }

    setIsDistanceResolved(false);
    // NOTE: distanceFromMe never rejects and never hangs; concurrent rows all
    // share one underlying geolocation request via locationService.
    distanceFromMe(defaultAddress.latitude, defaultAddress.longitude)
      .then((dist) => {
        if (cancelled) return;
        setDistance(dist);
        setIsDistanceResolved(true);
      });

    return () => {
      cancelled = true;
    };
  }, [defaultAddress]);

  return (
    <Stack gap={0} py={15}
      style={{
        borderBottom: "1px solid #F0F0F0"
      }}
      h="75px"
      onClick={() => onClick()}>
      <Group justify="space-between" align="center">
        <Text fz={20} fw="bold" truncate="end" maw="70%">
          {index}. {practitioner?.primary_name}
        </Text>
        {dataSourcePillText && (
          <Text 
            bg="#e53e3e" c="white" fz="0.8rem" 
            fw="500" p="2px 5px" bdrs="8px">
            {dataSourcePillText}
          </Text>
        )}
      </Group>
      <Group justify="space-between" align="center">
        {(address?.address1 || address?.address2) ? (
          <Box maw="75%" px={0} mx={0}>
            <Text fz={14} c="#8B8B8B" truncate="end">
              {address?.address1} {address?.address2}
            </Text>
            <Text fz={14} c="#8B8B8B" truncate="end">
              {address?.city}, {address?.state}, {address?.zipcode}
            </Text>
          </Box>
        ) : (
          <Text fz={14} c="#8B8B8B" maw="75%" px={0} mx={0}>
            {address?.address}
          </Text>
        )}
        <Text fz={14} fw="bold" c="#4F7D9C">
          {distance !== null
            ? `${distance} mi`
            : (isDistanceResolved ? '—' : '...')}
        </Text>
      </Group>
    </Stack>
  );
};

export default ListItem;